import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { PropertyCtaStatechartService } from 'common/module/property-cta/statechart/service';
import { PropertyLeadPhoneStore } from 'desktop/module/property-lead-phone/store';
import { PropertyCallTooltipService } from 'desktop/service/property-call-tooltip/service';

const service = new PropertyLeadPhoneStore(
  EventEmitterFactory(),
  PropertyCtaStatechartService(),
  PropertyCallTooltipService()
);

service.initialize();

export const PropertyLeadPhoneService = () => service;
